export const arrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    >
    <path d="M5.03551 13.5853L5.03552 13.5853L5.03828 13.5825L10.2633 8.23251L10.4918 7.9985L10.2622 7.76558L4.98716 2.41558L4.98717 2.41557L4.98551 2.41391C4.89068 2.31908 4.89068 2.18014 4.98551 2.08531C5.08005 1.99077 5.21846 1.99049 5.31326 2.08448C5.31354 2.08475 5.31382 2.08503 5.3141 2.08531L10.962 7.83324L10.962 7.83324L10.9641 7.83531C11.0604 7.93162 11.0665 7.97648 11.0665 7.99961C11.0665 8.05853 11.052 8.10958 10.9989 8.17936L5.36327 13.9147C5.26846 14.0087 5.13005 14.0085 5.03551 13.9139C4.94068 13.8191 4.94068 13.6801 5.03551 13.5853Z" fill="#012169" stroke="#012169" strokeWidth="0.666667"/>
  </svg>
);
